import IMask from 'imask';

import { Formatter, Validation } from '@philips-emr/tws-core/lib/services/model-service';

interface CustomFormatterOptions {
  name: string;
  mask: string | RegExp;
  validate(value: string): boolean;
  invalidMessage: string;
}

const noopValidate = (): boolean => true;

function createMask(mask: string | RegExp): IMask.MaskedRegExp | IMask.MaskedPattern {
  return typeof mask === 'string'
    ? new IMask.MaskedPattern({ mask, lazy: true })
    : new IMask.MaskedRegExp({ mask });
}

function createAlphanumericFormatter(options: CustomFormatterOptions): Formatter<string> {
  const { name, mask, validate: customValidate = noopValidate, invalidMessage = '' } = options;

  function format(value: string): string {
    const masked = createMask(mask);

    masked.unmaskedValue = String(value);

    return value ? masked.value : value;
  }

  function parse(value: string): string {
    const masked = createMask(mask);

    masked.value = String(value);

    return masked.unmaskedValue;
  }

  function validate(value: string): Validation[] {
    if (!value) {
      return [{ name, valid: true }];
    }

    const masked = createMask(mask);

    masked.value = String(value);

    const isMaskValid = Boolean(masked.isComplete && masked.doValidate({}));
    const isCustomValid = customValidate(value);
    const isValid = isMaskValid && isCustomValid;

    return [{
      name,
      valid: isValid,
      message: !isValid ? invalidMessage : '',
    }];
  }

  function getPattern(): string | RegExp {
    return mask;
  }

  return {
    format,
    getPattern,
    parse,
    validate,
  };
}

export default createAlphanumericFormatter;
